module.exports = __webpack_public_path__ + "static/media/18PerformancePhotos.cd2f24a2.jpeg";